export default __webpack_public_path__ + "static/media/chipsLimited.f2a53bfc.mp3";